import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import useEvent from '../hooks/useEvent';
import '../styles/sidebar.scss';

function Sidebar(props:any) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);

        let btn = document.querySelector(".settingsBtn") as HTMLElement;
        if (btn !== null) {
            if (!isMenuOpen) {
                //open!
                btn.style.zIndex = "2";
            } else {
                btn.style.zIndex = "1000";
            }
        }
    }


    const getToggleClass = () => {
        return isMenuOpen ? "open" : "";
    }

    const handleKeyPress = (e: KeyboardEvent) => {
        let key = e.key;

        switch (key) {
            case 'z':
                let btn = document.querySelector(".sidebar__hamburger") as HTMLElement;
                if (btn !== null) {
                    if (btn.style.zIndex !== "2") {
                        toggleMenu();
                    }
                }

                break;
            case '1':
                navigateIfOpen("/");
                break;
            case '2':
                navigateIfOpen("/resume");
                break;
            case '3':
                navigateIfOpen("/contact");
                break;
            case '4':
                navigateIfOpen("/showcase");
                break;
            case '5':
                navigateIfOpen("/faith");
                break;
            default:
                break;
        }
    }

    const navigateIfOpen = (route: string) => {
        if (!isMenuOpen) return;

        navigate(route)
    }

    useEvent('keydown', handleKeyPress);

    return (
        <>
            <div className="sidebar">
                <div className="sidebar__profile">
                </div>
                {props.children}
                <div className={`sidebar__hamburger ${getToggleClass()}`} onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className={`sidebar__overlay ${getToggleClass() === "open" ? "open fade-in" : "fade-out"}`} onClick={toggleMenu}></div>
                <div className='sidebar__menu'>
                    <Link to="/" className={`${getToggleClass() === "open" ? "open slide-in" : "fade-out"}`}>Home</Link>
                    <Link to="/resume" className={`${getToggleClass() === "open" ? "open slide-in" : "fade-out"}`} >Resume</Link>
                    <Link to="/contact" className={`${getToggleClass() === "open" ? "open slide-in" : "fade-out"}`}>Contact</Link>
                    <Link to="/showcase" className={`${getToggleClass() === "open" ? "open slide-in" : "fade-out"}`}>Projects</Link>
                    <Link to="/faith" className={`${getToggleClass() === "open" ? "open slide-in" : "fade-out"}`}>Faith</Link>
                </div>
            </div>
        </>
    )
}

export default Sidebar
